// extracted by mini-css-extract-plugin
export default {"container":"rldwT0VRdBVnoHjUYY3C","bottom":"RlYMODqypkjW8n_UOruv","right":"x0j1NbpG_eHX_vptzMu7","closer":"Fzq47voCxv1gD2DPwJnu"};